module.exports = __webpack_public_path__ + "img/xjp.2b3bdc58.png";